import React from 'react'

import styled from 'styled-components'

import PropItem from 'app/agency/stocklist/components/prop_item'
import { Box, Flex } from 'app/components/design-system-components'
import { Text } from 'app/components/design-system-components/typography'
import { theme } from 'app/match/applicationReportPDF/assets/theme'
import * as helpers from 'app/sm/helpers'

const MainHeading = styled.h1`
  font-size: ${theme.fontSizes[4]}px;
  font-weight: ${theme.fontWeights.h1};
  color: ${theme.colors.gray900};
  margin-bottom: ${theme.space[1]}px;
`

const AgencyAddressText = styled(Text)`
  font-size: ${theme.fontSizes[3]}px;
  margin-bottom: ${theme.space[1]}px;
  color: ${theme.colors.gray700};
`

const ContactFlex = styled(Flex)`
  font-size: ${theme.fontSizes[3]}px;
  flex-wrap: wrap;
  gap: ${theme.space[1]}px;
`

const ContactBox = styled(Box)`
  margin-right: ${theme.space[1]}px;
`

const ContactLink = styled(Text)`
  font-size: ${theme.fontSizes[3]}px;
  color: ${theme.colors.primary};
  text-decoration: underline;
`

const AgencyLogo = styled.img`
  max-width: 160px;
  height: auto;
  @media print {
    max-width: 120px;
    height: auto;
  }
`

const PropertyListContainer = styled(Box)`
  margin-top: ${theme.space[2]}px;
`

const Layout = ({ teamSlug = '', agencyDetails = {}, properties = [] }) => {
  const {
    agencyName = '',
    contactNumber = '',
    contactEmail = '',
    address = {},
    brandingLogoURL = '',
  } = agencyDetails
  const { friendlyName = '', suburb = '', state = '', postcode = '' } = address
  const formattedAddress = `${friendlyName}, ${suburb} ${helpers.stateConverter(
    state,
  )} ${postcode}`
  const contactDetails = [
    {
      text: 'T',
      class: '',
      contactLink: `tel:${contactNumber}`,
      contactText: contactNumber,
    },
    {
      text: 'E',
      class: '',
      contactLink: `mailto:${contactEmail}`,
      contactText: contactEmail,
    },
    {
      text: 'W',
      class: 'next-row',
      contactLink: `${helpers.urlTo('teamPublicPage', { teamSlug })}`,
      contactText: `snug.com/apply/${teamSlug}`,
    },
  ]
  return (
    <Box className="container">
      <Flex justifyContent="space-between">
        <Box flex="1">
          <MainHeading>{agencyName}</MainHeading>
          <AgencyAddressText>{formattedAddress}</AgencyAddressText>
          <ContactFlex>
            {contactDetails
              .filter(
                (contactDetail) =>
                  contactDetail && contactDetail.contactText !== '',
              )
              .map((contactDetail, index) => {
                return (
                  <ContactBox key={index} className={contactDetail.class}>
                    {contactDetail.text}
                    <ContactLink
                      as="a"
                      className="link-basic"
                      href={contactDetail.contactLink}
                    >
                      {' '}
                      {contactDetail.contactText}
                    </ContactLink>
                  </ContactBox>
                )
              })}
          </ContactFlex>
        </Box>
        <Box>
          {brandingLogoURL && <AgencyLogo src={brandingLogoURL} alt="prop" />}
        </Box>
      </Flex>
      <PropertyListContainer className="prop-item-wrap">
        {(properties || []).map((property, index) => (
          <PropItem key={index} data={property} />
        ))}
      </PropertyListContainer>
    </Box>
  )
}

export default Layout
